<template>
  <img :src="imageSource" :alt="alt" :class="imgClass"/>
</template>
<script>
  const VIDOE_THEME = 'vidoe';
  const VIDOE_DARK_THEME = 2;
export default {
  data() {
    return {
      imageSource: this.src
    };
  },
  props: [
    'src',
    'alt',
    'imgClass'
  ],
  mounted() {
    //Fix me!!
    //@todo Refactor this to a proper implementation. Implemented as a quixk fix to solve the problem
    // when a theme is having different styles and we need to load the right logo color that will
    // match with the header background where the logo is positioned.
    this.imageSource = this.src + '.png';
    if (template === VIDOE_THEME && globalSite.template_id === VIDOE_DARK_THEME) {
      this.imageSource = this.src + "-white.png";
    }
  }
}
</script>
<style>
  .img-logo {
    width:120px;
    max-width: 100%;
    height: auto;
  }
  .position-logo {
    padding: 17px 0px 8px 0px;
  }
  @media (max-width: 575.98px) {
    .position-logo {
      left: 50%;
      position: relative;
      padding: 14px 0px 8px 0px;
    }
  }
</style>